{
  "version": 1,
  "asset_id": "6224432f-b2e0-4b8c-a3c7-5b2d63654259",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6224432f-b2e0-4b8c-a3c7-5b2d63654259/lighting-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6224432f-b2e0-4b8c-a3c7-5b2d63654259/lighting-hero.webp",
  "original_filename": "lighting-hero.webp",
  "size": 37050,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:58Z"
}
